import { Command } from 'commander';
import { WorkflowManager } from '../core/workflow-manager';
import { logger } from '../utils/logger';
import pc from 'picocolors';

export function createStatusCommand(): Command {
  const command = new Command('status');

  command
    .description('Show current workflow status')
    .option('-j, --json', 'Output as JSON')
    .action(async (options) => {
      try {
        const manager = new WorkflowManager();
        const status = await manager.getWorkflowStatus();

        if (!status) {
          logger.info('No active workflow. Use "workflow start <type>" to begin.');
          return;
        }

        if (options.json) {
          console.log(JSON.stringify(status, null, 2));
          return;
        }

        // Display formatted status
        logger.info('');
        logger.info(pc.bold('📊 Workflow Status'));
        logger.info('');
        logger.info(`Type: ${pc.cyan(status.type)}`);
        logger.info(`Name: ${pc.cyan(status.name)}`);
        logger.info(`Started: ${pc.gray(new Date(status.startedAt).toLocaleString())}`);
        logger.info('');
        logger.info(pc.bold('Phases:'));
        
        status.phases.forEach((phase, index) => {
          const isCurrent = index === status.currentPhase;
          const icon = phase.status === 'completed' ? '✅' : 
                      phase.status === 'in_progress' ? '🔄' : '⏳';
          const prefix = isCurrent ? pc.bold('▶ ') : '  ';
          
          logger.info(`${prefix}${icon} ${phase.name}`);
          
          if (phase.completedTasks.length > 0) {
            phase.completedTasks.forEach(task => {
              logger.info(`     ✓ ${pc.gray(task)}`);
            });
          }
        });

        // Show progress
        const totalPhases = status.phases.length;
        const completedPhases = status.phases.filter(p => p.status === 'completed').length;
        const progress = Math.round((completedPhases / totalPhases) * 100);
        
        logger.info('');
        logger.info(`Progress: ${pc.green('█'.repeat(Math.floor(progress / 5)))}${pc.gray('░'.repeat(20 - Math.floor(progress / 5)))} ${progress}%`);
        logger.info('');

        // Show next steps
        const currentPhase = status.phases[status.currentPhase];
        if (currentPhase && currentPhase.status !== 'completed') {
          logger.info(pc.bold('Next steps:'));
          logger.info(`Complete tasks in "${currentPhase.name}" phase`);
          logger.info('Use "workflow complete" to mark tasks as done');
        }
      } catch (error: any) {
        logger.error('Failed to get status:', error.message);
        if (process.env.DEBUG) {
          console.error(error);
        }
        process.exit(1);
      }
    });

  return command;
}